import dayjs from 'dayjs';
import React, { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { Tag } from '@carbon/react';

interface BacklogPanelProps {
  title: string;
  items: Array<{ id: string; title: string; label: string; tagType: string; createdAt: string }>;
}

const BacklogPanel = React.memo((props: BacklogPanelProps) => {
  const { t } = useTranslation('dashboard');
  const headingId = useId();
  return (
    <div className="dashboard__stat_widget">
      <h4 id={headingId}>{props.title}</h4>
      {props.items.length === 0 && <p>{t('translation:common.none')}</p>}
      <ul aria-labelledby={headingId}>
        {props.items.map((item) => (
          <li key={item.id}>
            {item.title}{' '}
            <Tag type={item.tagType as never} size="sm">
              {item.label}
            </Tag>{' '}
            {dayjs(item.createdAt).fromNow()}
          </li>
        ))}
      </ul>
    </div>
  );
});

export default BacklogPanel;
